import { generateApiUrl, request } from '@/utils/ajax';
import {
    ConfiguratorBackendDto,
    ConfiguratorBackendRequest,
    ConfiguratorPreviewRoomDto,
    ConfiguratorSourceDto,
    ConfiguratorValidationStructureDto,
} from './configurator-backends.types';

export function getConfiguratorBackends(projectId: number): Promise<ConfiguratorBackendDto[]> {
    return request(`api/project/${projectId}/configurator-backends`).then((x) => x.json());
}

export function getConfiguratorSources(projectId: number): Promise<ConfiguratorSourceDto[]> {
    return request(`api/project/${projectId}/configurator-backends/sources`).then((x) => x.json());
}

export function getConfiguratorValidationStructure(projectId: number): Promise<ConfiguratorValidationStructureDto> {
    return request(`api/project/${projectId}/configurator-backends/validation-structure`).then((x) => x.json());
}

export function getConfiguratorPreviewRooms(projectId: number, projectKey: string): Promise<ConfiguratorPreviewRoomDto[]> {
    return request(`api/project/${projectId}/configurator-backends/preview-rooms`, { query: { projectKey } }).then((x) => x.json());
}

export function getConfiguratorBackend(projectId: number, id: number): Promise<ConfiguratorBackendDto> {
    return request(`api/project/${projectId}/configurator-backends/${id}`).then((x) => x.json());
}

export function createConfiguratorBackend(projectId: number, body: ConfiguratorBackendRequest): Promise<ConfiguratorBackendDto> {
    return request(`api/project/${projectId}/configurator-backends`, { method: 'post', body, json: true }).then((x) => x.json());
}

export function updateConfiguratorBackend(projectId: number, id: number, body: ConfiguratorBackendRequest): Promise<ConfiguratorBackendDto> {
    return request(`api/project/${projectId}/configurator-backends/${id}`, { method: 'put', body, json: true }).then((x) => x.json());
}

export function deleteConfiguratorBackend(projectId: number, id: number): Promise<Response> {
    return request(`api/project/${projectId}/configurator-backends/${id}`, { method: 'delete' });
}

export function getConfiguratorMappingExportUrl(projectId: number): string {
    return generateApiUrl(`/api/project/${projectId}/configurator-backends/export`);
}
